import { Fragment } from "react/jsx-runtime";
import CustomTextInputProps from "../../../services/models/customTextInputProps.mode";
import CustomTextInput from "../CustomTextInput";
import CustomRadioInputProps from "../../../services/models/customRadioInput.model";
import CustomRadioInput from "../../molecular/CustomRadioInput";
import CustomCheckBoxInputProps from "../../../services/models/customCheckBoxInput.model";
import CustomCheckBoxInput from "../../molecular/CustomCheckboxInput";
import ArrayInput from "../../organism/ArrayInput";
import ArrayInputProps from "../../../services/models/formModels/MultiStepForm/arrayInputProps.model";
import CustomImageUploaderProps from "../../../services/models/customImageUploader.model";
import ImageUploader from "../ImageUploader";
import CustomSuggestiveInputProps from "../../../services/models/CustomSuggestiveInputProps.model";
import CustomSuggestiveInput from "../../organism/CustomSuggestiveInput";
import CustomFileUploaderProps from "../../../services/models/customFileUploader.model";
import FileUploader from "../FileUploader";
import CustomDateInput from "../CustomDateInput";
import CustomDateInputProps from "../../../services/models/customDateInputProps.model";
import SelectProps from "../../../services/models/customSelectProps.model";
import CustomSelect from "../../organism/CustomSelect";

import FieldRendererProps from "../../../services/models/fieldRendererProps.model";

function FieldRenderer({
  fields,
}: Readonly<FieldRendererProps>): JSX.Element {
  return (
    <Fragment>
      {fields.map((field, index) => {
        if (field.type === 'date') {
          return <CustomDateInput key={(field as CustomDateInputProps).labelInfo?.inputId} {...field} />
        }
        if ((field as SelectProps).isForm) return <CustomSelect
          key={(field as SelectProps).isForm?.labelInfo.inputId}
          {...(field as SelectProps)}
        />

        if ((field as CustomFileUploaderProps).type === "file") {
          return (
            <FileUploader
              key={(field as CustomFileUploaderProps).labelInfo?.inputId}
              {...(field as CustomFileUploaderProps)}
            />
          );
        }
        if ((field as CustomSuggestiveInputProps)?.suggestions) {
          return (
            <CustomSuggestiveInput
              key={(field as CustomTextInputProps).labelInfo?.inputId}
              {...(field as CustomSuggestiveInputProps)}
            />
          );
        }
        if ((field as ArrayInputProps)?.arrayName) {
          const arrayField = field as ArrayInputProps;
          return (
            <ArrayInput
              key={`${arrayField.arrayName}${index}`}
              {...arrayField}
            />
          );
        }
        if ((field as CustomCheckBoxInputProps).checkBoxes) {
          return (
            <CustomCheckBoxInput
              key={(field as CustomCheckBoxInputProps).labelInfo?.inputId}
              {...(field as CustomCheckBoxInputProps)}
            />
          );
        }

        if ((field as CustomRadioInputProps).options) {
          return (
            <CustomRadioInput
              key={(field as CustomRadioInputProps).labelInfo?.inputId}
              {...(field as CustomRadioInputProps)}
            />
          );
        }
        if ((field as CustomImageUploaderProps).image) {
          return (
            <ImageUploader
              key={(field as CustomImageUploaderProps).labelInfo?.inputId}
              {...(field as CustomImageUploaderProps)}
            />
          );
        }

        return (
          <CustomTextInput
            key={(field as CustomTextInputProps).labelInfo?.inputId}
            {...field}
          />
        );
      })}
    </Fragment>
  );
}

export default FieldRenderer;
